import { takeLatest, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import uuid from 'uuid';
import * as api from 'data/api';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { AbTestVariant } from 'constants/abtest';
import { actions } from './slice';
import * as statelessActions from './actions';
import { transformBundleSummary, transformInstantBundleSummary } from './transformers';
export function* setSelectedItems(_ref) {
  let {
    payload: {
      itemIds,
      userId
    }
  } = _ref;
  const instantBundlesAbTest = yield* select(getAbTestByName('instant_bundles'));
  const instantBundleFeatureSwitch = yield* select(getIsFeatureSwitchEnabled('instant_bundles'));
  const isInstantBundlesFeatureEnabled = (instantBundlesAbTest === null || instantBundlesAbTest === void 0 ? void 0 : instantBundlesAbTest.variant) === AbTestVariant.On && instantBundleFeatureSwitch;

  if (isInstantBundlesFeatureEnabled) {
    yield put(statelessActions.getInstantBundleOrderReviewRequest({
      itemIds,
      userId
    }));
  } else {
    yield put(statelessActions.getBundleSummaryRequest({
      itemIds,
      userId
    }));
  }
}
export function* createBundleSummary(_ref2) {
  let {
    payload: {
      itemIds,
      userId
    }
  } = _ref2;
  const response = yield* call(api.createBundleSummary, {
    itemIds,
    sellerId: userId
  });

  if ('errors' in response) {
    yield put(statelessActions.getBundleSummaryFailure());
    return;
  }

  if (response) {
    yield put(actions.getBundleSummarySuccess({
      bundleSummary: transformBundleSummary(response.bundle_summary)
    }));
  }
}
export function* getInstantBundleOrderReview(_ref3) {
  let {
    payload: {
      itemIds,
      userId
    }
  } = _ref3;
  const response = yield* call(api.getBundleOrderReview, {
    itemIds,
    sellerId: userId
  });

  if ('errors' in response) {
    yield put(statelessActions.getBundleSummaryFailure());
    return;
  }

  if (response) {
    yield put(actions.getInstantBundleSummarySuccess({
      instantBundleSummary: transformInstantBundleSummary(response.bundle_order_review)
    }));
  }
}
export function* startBundling() {
  const bundleTrackingId = uuid.v4();
  yield put(actions.setBundleTrackingId({
    bundleTrackingId
  }));
}
export default function* saga() {
  yield takeLatest(actions.startBundling, startBundling);
  yield takeLatest(actions.setSelectedItems, setSelectedItems);
  yield takeLatest(statelessActions.getBundleSummaryRequest, createBundleSummary);
  yield takeLatest(statelessActions.getInstantBundleOrderReviewRequest, getInstantBundleOrderReview);
}